
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f72Ys", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a68618604fa10eaa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $a68618604fa10eaa$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'Alle Sites',
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': 'Analysen',
    'navigation.global-shortcuts.apps.assets': 'Assets',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Unternehmens-Hub',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Ziele',
    'navigation.global-shortcuts.apps.home': 'Startseite',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projekte',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Teams',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': "Schlie\xdfen",
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name}-Site',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(derzeit nicht verf\xfcgbar)",
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': "Symbol: externen Link \xf6ffnen",
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(wird geladen)',
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(wird geladen)',
    'navigation.global-shortcuts.shortcut-action.open-menu-label': "Men\xfc \xf6ffnen",
    'navigation.global-shortcuts.sites': "{productName}\xa0Sites"
};

});


//# sourceMappingURL=de.d4c13fbb.js.map
